import AreaButton from 'components/AreaButton';
import CartPanel from 'components/CartPanel';
import ForgetForm from 'components/ForgetForm';
import HelpPanel from 'components/HelpPanel';
import LoginForm from 'components/LoginForm';
import RegisterForm from 'components/RegisterForm';
import StoryPanel from 'components/StoryPanel';

export default function Elements() {
  return (
    <>
      <RegisterForm />
      <LoginForm />
      <ForgetForm />
      <StoryPanel />
      <AreaButton />
      <CartPanel />
      <HelpPanel />
    </>
  );
}
